import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { LotsGrid, LotsGridPluginSettings } from ".";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";
import styles from './styles/LotsCreatorModal.module.scss'

const LotsSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO | undefined>(props.selectedEntity ?? undefined);
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntity ?? []);
    const gridId = uuidv4();
    const plugin = LotsGridPluginSettings
    const { t } = useTranslation();


    return (
        <GridSelectorModalWindow
            modalWindowClassName={styles.lotSelectorModal}
            entityToPressEnter={entity}
            fullScreen={true}
            onlyGridDisplayName={props.onlyGridDisplayName}
            gridDisplayName={plugin?.name ?? t('accounting.lots.title')}
            ok={{ onClick: () => props.ok?.(entities.length > 0 ? entities : entity) }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin
                    ? <LotsGrid
                        activateGroupProcessing={props.activateGroupProcessing ?? false}
                        data={entities}
                        isModal
                        onlyLotRemain={props.onlyLotRemain}
                        baseGridFilter={props.gridFilter}
                        dispatchGridFilter={props.dispatchGridFilter}
                        gridId={gridId}
                        plugin={plugin}
                        onSelect={(row) => {
                            setEntity(row ? { idGlobal: row.idGlobal, displayName: row.displayName } : undefined);
                        }}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                        onMultipleSelect={(rows) => {
                            setEntities(rows.length > 0 ? rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)) : [])
                        }}
                    />
                    : <p>{t('general.directoryNotConfigured')}</p>
            }
        </GridSelectorModalWindow>
    )
}

export default LotsSelectorModal